import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "@core/services";
import { ApiResponse, CreateScheduleRequest, ModifyScheduleLockRequest, ModifyScheduleLockResponse, SaveScheduleChangesRequest, ScheduleItem, ShiftStatusCheckRequest } from "@core/types";

const SCHEDULE_API = {
  GET_SCHEDULES: "api/schedule/schedules",
  CREATE_SCHEDULE: "api/schedule/create-schedule",
  UPDATE_SCHEDULE: "api/schedule/update-schedule",
  SAVE_CHANGES: "api/schedule/save-schedule-changes",
  GET_SHIFT_STATUS: "api/schedule/get-shift-status",
  MODIFY_LOCK: "api/schedule/modify-schedule-lock",
};

@Injectable({ providedIn: "root" })
export class ScheduleService {
  private readonly api = inject(ApiService);

  getSchedules(organizationId: number, scheduleGroupId: number, startDateTime: string, endDateTime: string): Observable<ApiResponse<ScheduleItem[]>> {
    return this.api.get<ScheduleItem[]>(SCHEDULE_API.GET_SCHEDULES, {
      params: { organizationId, scheduleGroupId, startDateTime, endDateTime },
    });
  }

  createSchedule(payload: CreateScheduleRequest): Observable<ApiResponse<number>> {
    return this.api.post<number>(SCHEDULE_API.CREATE_SCHEDULE,  payload);
  }

  updateSchedule(payload: CreateScheduleRequest): Observable<ApiResponse<number>> {
    return this.api.post<number>(SCHEDULE_API.UPDATE_SCHEDULE,  payload );
  }

  saveScheduleChanges(payload: SaveScheduleChangesRequest): Observable<ApiResponse<number>> {
    return this.api.post<number>(SCHEDULE_API.SAVE_CHANGES,  payload );
  }

  shiftStatus(queryParams: ShiftStatusCheckRequest): Observable<ApiResponse<number>> {
    return this.api.get<number>(SCHEDULE_API.GET_SHIFT_STATUS, { params: queryParams });
  }


  modifyScheduleLock(payload: ModifyScheduleLockRequest): Observable<ApiResponse<ModifyScheduleLockResponse>> {
    return this.api.post<ModifyScheduleLockResponse>(SCHEDULE_API.MODIFY_LOCK,  payload );
  }
}
